import { useMutation } from '@tanstack/react-query';
import { updateInboxOrder } from 'shared/services/backend-api';
import { ID } from 'shared/types/id';

export const useUpdateInboxOrderMutation = () =>
  useMutation({
    mutationFn: async (newOrder: ID[]) => updateInboxOrder(newOrder),
  });
